/** Version applicative envoyée dans le header App-Version de chaque requête API. */
export const APP_VERSION = '0.1.0';

/** Version de l'API négociée via le header Accept (application/vnd.iman.v{n}+json). */
export const API_VERSION = '1';

/**
 * Identifiant de plateforme envoyé dans le header m-plateforme.
 *
 * @remarks
 * 7 = ApplicationOnlineLifecycle (réservé à ce projet). Ne JAMAIS utiliser 5 (Front web)
 * ni 6 (application mobile Flutter). Valeur miroir de `ePlateforme.ApplicationOnlineLifecycle`
 * (KeepControlWeb.Models/SuiviLog.cs).
 */
export const PLATFORM_ID_ONLINE_LIFECYCLE = '7';
